<template>
    <div class="hand layout-page-box">
        <div class="layTitle">
            <div class="title">手术病人护理、交接记录</div>
            <div>
                <el-button type="danger" size="small" @click="close">返回留观管理</el-button>
            </div>
        </div>
        <el-form :inline="true" :model="formData" class="formBox">
            <el-form-item label="科室">
                <el-select disabled v-model="formData.departmentName" clearable placeholder="请选择科室" style="width:60%;">
                    <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="床号">
                <el-input disabled v-model.trim="formData.bedNumber" style="width:60%;" placeholder="请输入床号"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input disabled v-model.trim="formData.clientName" style="width:60%;" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-select disabled v-model="formData.clientSex" clearable placeholder="请选择性别" style="width:60%;">
                    <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <first :formData="formData" @change="costPlannedAmountChange($event)" ref="first"></first>
        <second :formData="formData" v-if="secondModule" :secondDisabled="secondDisabled" ref="second" :secondButtonDisabled="secondButtonDisabled"></second>
        <third :formData="formData" v-if="thirdModule" :thirdDisabled="thirdDisabled" ref="third"></third>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import first from './first'
import second from './second'
import third from './third'
export default {
    name: 'hand',
    // props: ['formData'],
    computed: {
        ...mapState(["sexey",]),
    },
    components: {
        first, second, third
    },
    data() {
        return {
            offices: [
                {
                    name: '美容皮肤科',
                    id: '001'
                },
                {
                    name: '美容外科',
                    id: '002'
                },
                {
                    name: '注射微整科',
                    id: '003'
                },
            ],
            secondModule: false,
            thirdModule: false,
            thirdDisabled: false,
            secondDisabled: false,
            secondButtonDisabled: false,
            formData: {
                // first
                auditType: 0,
                departmentName: '美容外科',
                vitalSignsPreoperative: {},
                generalPreparation: [],
                bowelPreparation: [],
                bowelPreparationOther: '',
                catheterization: [],
                skinPreoperative: [],
                positionPreoperative: [],
                // second
                tubes: [],
                anesthesiaMode: [],
                awarenessState: [],
                vitalSignsPostoperative: {},
                decubitusPosition: [],
                // catheterizationPostoperative: [],
                skinPostoperative: [],
                medicationPostoperative: {
                    infusion: '',
                    transfusion: '',
                    returnInfusion: '',
                },
                placement: [
                    {
                        type: '1',
                        name: '',
                        data: '',
                        colour: '',
                    },
                    {
                        type: '2',
                        name: '',
                        data: '',
                        colour: '',
                    },
                    {
                        type: '3',
                        name: '',
                        data: '',
                        colour: '',
                    },
                    {
                        type: '5',
                        name: '',
                        data: '',
                        colour: '',
                    },
                    {
                        type: '4',
                        name: '',
                        data: '',
                        colour: '',
                    },
                ],
                // third
                psychologicalNursing: [],
                diet: [],
                position: [],
                incision: [],
                conduit: [],
                propagandaEducation: [],
                passData: '',
            },
            lists: {},
            leaveObserve: Lockr.get('leaveObserve'),
        }

    },
    // 解决切换页面多次调用路由问题
    activated() {
        this.activatedFlag = true
        if (this.formData.auditType && this.activatedFlag) {
            this.init()
            this.query()
        }
    },
    deactivated() { this.activatedFlag = false; },
    created() {
        this.init()
        api.request("/employee/findEmployeeListAll", {}, (res) => {
            this.lists = res.data.createByList
        })
    },
    mounted() {
        this.$store.dispatch('getnurseNoList')
        this.query()
    },
    methods: {
        query() {
            // console.log('当前交接状态');
            // console.log(this.formData.auditType);
            // if (this.leaveObserve == 1) {
            //     this.$refs.first.buttonFlase()//第一模块按钮取消禁用
            //     // 三个模块取消禁止编辑
            //     this.$refs.first.toHand()
            //     this.secondDisabled = false
            //     this.thirdDisabled = false
            //     this.secondButtonDisabled = false//第二模块按钮取消禁用
            //     this.firstInit()
            // } else {
            this.secondButtonDisabled = false
            if (this.formData.auditType == 0) {
                this.secondModule = false//术前审核结束需要确认审核
                this.thirdModule = false
                this.$refs.first.buttonFlase()// 术前准备提交按钮显示
                //术前审核结束需要确认审核
                if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {//
                    // 术前审核已经交接
                    this.$refs.first.handMethod()
                } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {//待确认
                    this.$refs.first.toHand()
                    // // 判断是否是本人账号添加的可以修改 不是本人账号添加的禁止修改
                    if (Lockr.get("skinUserName") == this.formData.preoperativeSignature) {
                        this.$refs.first.toHand()
                    } else if (Lockr.get("skinUserName") != this.formData.preoperativeSignature) {
                        this.$refs.first.handMethod()
                    }
                }
            } else if (this.formData.auditType == 1) {
                this.secondModule = false
                this.thirdModule = false
                if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {
                    this.$refs.first.handMethod() // 术前审核已经交接
                    this.$refs.first.buttonFlase()// 术前准备提交按钮显示
                } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {
                    // 判断是否是本人账号添加的可以修改 不是本人账号添加的禁止修改
                    if (Lockr.get("skinUserName") == this.formData.preoperativeSignature) {
                        this.$refs.first.toHand()
                    } else if (Lockr.get("skinUserName") != this.formData.preoperativeSignature) {
                        this.$refs.first.handMethod()
                    }
                }
            } else if (this.formData.auditType == 2) {
                this.secondModule = true// 术前审核已经确认 展示第二模块
                this.thirdModule = false// 术前审核已经确认 展示第二模块
                this.$refs.first.handMethod()
                this.$refs.first.buttonTrue()// 术前准备提交按钮禁用
                this.secondButtonDisabled = false
                if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {
                    //可以编辑第二部分的权限
                    this.secondDisabled = false
                } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {
                    this.secondDisabled = true
                }
            } else if (this.formData.auditType == 3) {
                this.secondModule = true
                this.thirdModule = false
                this.$refs.first.handMethod()
                // 术前准备提交按钮禁用
                this.$refs.first.buttonTrue()
                if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {
                    //可以编辑第二部分的权限
                    this.secondDisabled = false
                } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {
                    this.secondDisabled = true
                }
            } else if (this.formData.auditType == 4) {
                this.secondModule = true
                this.thirdModule = true
                this.$refs.first.handMethod()//完成交接后第一模块不可修改
                this.secondDisabled = true//完成交接后第二模块不可修改
                this.secondButtonDisabled = true //术后情况按钮禁用
                this.$refs.first.buttonTrue()// 术前准备提交按钮禁用
                if (Lockr.get("skinEmpId") == this.formData.postoperativeNurseNo) {//
                    // 术前审核已经交接
                    this.thirdDisabled = false
                } else if (Lockr.get("skinEmpId") != this.formData.postoperativeNurseNo) {
                    this.thirdDisabled = true
                }
            }
            // }

        },

        firstInit() {
            if (this.formData.auditType == 0) {
                this.secondModule = false//术前审核结束需要确认审核
                this.thirdModule = false
            } else if (this.formData.auditType == 1) {
                this.secondModule = false
                this.thirdModule = false
            } else if (this.formData.auditType == 2) {
                this.secondModule = true// 术前审核已经确认 展示第二模块
                this.thirdModule = false// 术前审核已经确认 展示第二模块
            } else if (this.formData.auditType == 3) {
                this.secondModule = true
                this.thirdModule = false
            } else if (this.formData.auditType == 4) {
                this.secondModule = true
                this.thirdModule = true
            }
        },

        secondMethod() {
            this.secondModule = true
        },
        toSecond() {
            this.secondModule = false
        },

        thirdMethod() {
            this.thirdModule = true
        },
        toThird() {
            this.thirdModule = false
        },

        init() {
            this.passData = this.$route.params
            // console.log(this.passData);
            if (this.passData.code == 1) {
                this.formData = this.passData
            } else if (this.passData.code == 0) {
                this.formData = {
                    // first
                    auditType: 0,
                    departmentName: '美容外科',
                    generalPreparation: [],
                    bowelPreparation: [],
                    bowelPreparationOther: '',
                    catheterization: [],
                    skinPreoperative: [],
                    positionPreoperative: [],
                    skinTest: '',
                    bowelPreparationOther: '',
                    catheterizationOther: "",
                    vitalSignsPreoperative: {
                        time: '',
                        centigrade: '',
                        pulse: '',
                        breathe: '',
                        bloodPressure: '',
                    },
                    skinPreoperativeOther: '',
                    drugPreoperative: '',
                    articlePreoperative: '',
                    preoperativeSignature: Lockr.get("skinUserName"),
                    preoperativeNurseNo: '',
                    preoperativeNurseName: '',
                    preoperativeRemarks: '',
                    // second
                    operationNamePostoperative: '',
                    observationRoomTime: '',
                    anesthesiaModeOther: '',
                    vitalSignsPostoperative: {
                        time: '',
                        centigrade: '',
                        pulse: '',
                        breathe: '',
                        bloodPressure: '',
                    },
                    decubitusPositionOther: '',
                    skinPostoperativeOther: '',
                    drugPostoperative: '',
                    articlePostoperative: '',
                    postoperativeNurseName: '',
                    tubes: [],
                    anesthesiaMode: [],
                    awarenessState: [],
                    decubitusPosition: [],
                    // catheterizationPostoperative: [],
                    skinPostoperative: [],
                    medicationPostoperative: {
                        infusion: '',
                        transfusion: '',
                        returnInfusion: '',
                    },
                    placement: [
                        {
                            type: '1',
                            name: '',
                            data: '',
                            colour: '',
                        },
                        {
                            type: '2',
                            name: '',
                            data: '',
                            colour: '',
                        },
                        {
                            type: '3',
                            name: '',
                            data: '',
                            colour: '',
                        },
                        {
                            type: '5',
                            name: '',
                            data: '',
                            colour: '',
                        },
                        {
                            type: '4',
                            name: '',
                            data: '',
                            colour: '',
                        },
                    ],
                    // third
                    psychologicalNursing: [],
                    diet: [],
                    position: [],
                    incision: [],
                    conduit: [],
                    propagandaEducation: [],
                    passData: '',
                    postoperativeDate: '',
                    postoperativeTime: '',
                    positionOther: '',
                    propagandaEducationOther: '',
                    nurseName: '',
                }
            }
            this.formData.bedNumber = this.passData.bedNumber
            this.formData.clientName = this.passData.clientName
            this.formData.clientSex = this.passData.clientSex
            this.formData.code = this.passData.code
            // console.log('this.formData');
            // console.log(this.formData);
        },
        close() {
            router.push('/observation/observation')
        },
        getData() {
            this.formData.generalPreparation = this.formData.generalPreparation.toString()
            this.formData.bowelPreparation = this.formData.bowelPreparation.toString()
            this.formData.catheterization = this.formData.catheterization.toString()
            this.formData.skinPreoperative = this.formData.skinPreoperative.toString()
            this.formData.positionPreoperative = this.formData.positionPreoperative.toString()
            this.formData.anesthesiaMode = this.formData.anesthesiaMode.toString()
            this.formData.awarenessState = this.formData.awarenessState.toString()
            this.formData.decubitusPosition = this.formData.decubitusPosition.toString()
            this.formData.skinPostoperative = this.formData.skinPostoperative.toString()
            this.formData.psychologicalNursing = this.formData.psychologicalNursing.toString()
            this.formData.diet = this.formData.diet.toString()
            this.formData.position = this.formData.position.toString()
            this.formData.incision = this.formData.incision.toString()
            this.formData.conduit = this.formData.conduit.toString()
            this.formData.propagandaEducation = this.formData.propagandaEducation.toString()
        },
        sure() {
            console.log(this.formData);
            this.getData()
            // 置管情况数据处理
            let arr = this.formData.placement.filter((item) => {
                if (this.formData.tubes.indexOf(item.type) > -1) {
                    return item;
                }
            });
            arr.push({
                type: '5',
                name: this.formData.placement[3].name,
                data: this.formData.placement[3].data,
                colour: this.formData.placement[3].colour,
            }, )
            this.formData.catheterizationPostoperative = arr
            this.formData.createBy = Lockr.get('skinEmpId');
            // console.log(this.formData.preoperativeNurseNo);
            this.lists.forEach(item => {
                if (item.id == this.formData.preoperativeNurseNo) {
                    this.formData.preoperativeNurseName = item.userName
                }
            });
            this.formData.leaveObserve = Lockr.get('leaveObserve');
            // 新增
            if (this.formData.code == 0) {
                this.formData.leaveObserveId = this.passData.id;
                api.requestQuiet("/leaveObserve/createHandoverRecord", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '添加成功');
                        router.push({ path: '/observation/observation', query: { code: 0 }, })
                        //  router.push({ name: 'observation', params: data })
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (this.formData.code == 1) {
                this.formData.leaveObserveId = this.formData.leaveObserveId;
                api.requestQuiet("/leaveObserve/updateHandoverRecord", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '修改成功');
                        router.push({ path: '/observation/observation', query: { code: 0 } })
                        // router.push('/observation/observation')
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }
        }
    },
}
</script>
<style scoped>
/* @import "../../assets/css/main.css"; */
.title {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 0;
}
.people {
  margin-right: 20px;
}
.sureButton {
  display: flex;
}
.handForm {
  border: 1px solid #eee;
}
.partFooter {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
/* .layout-page-box >>> .el-form-item {
  margin-bottom: 10px !important;
} */
.formBox >>> .el-form-item__label {
  line-height: 40px !important;
}
.layTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


